import { render, staticRenderFns } from "./SaveResultModal.vue?vue&type=template&id=51814bec&scoped=true&"
import script from "./SaveResultModal.vue?vue&type=script&lang=js&"
export * from "./SaveResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51814bec",
  null
  
)

export default component.exports